<template>
    <form
        ref="form"
        @submit.prevent="submit"
        :action="formRoute"
        method="POST"
        class="relative h-full"
    >
        <page-header
            :submit-button-text="data ? 'Update' : 'Create Meta'"
            :show-submit-button="true"
            :submit-button-disabled="submitButtonDisabled || !editable"
            submit-button-type="submit"

            :can-delete="canDelete"
            :delete-route="deleteRoute"
            :delete-value="deleteValue"

            :can-create="canCreate"
            :create-route="createRoute"
            :create-value="createValue"

            :index-route="indexRoute"
            :index-value="indexValue"
            :title="title"
            :subtitle="subtitle"

            :show-preview-button="false"

            :errors="errors"
            :is-slide-over="isSlideOver"

            :version-id="versionId"
            :init-version-id="initVersionId"
            :last-updated-by="lastUpdatedBy"
        />

        <input-rich-text
            name="editor_note"
            label="Editor's note"
            v-model="form.editor_note"
            :language="form.language"
            :error="errors.editor_note ? errors.editor_note[0] : null"
            :maxlength="60000"
        />
        <p class="my-1 text-xs text-gray-600 mb-3">The note is for internal use only and won’t be displayed on the site</p>

        <p>You can use these available shortcodes in the title and description fields below: [current_year], [current_month] and [current_abrev_month]</p>
        <input-text
            name="name"
            label="* Name (This field is for CMS naming purposes only)"
            class="mt-6"
            v-model="form.name"
            :error="errors.name ? errors.name[0] : null"
            :maxlength=255
        />
        <input-text
            label="* Meta Title"
            name="title"
            v-model="form.title"
            class="mt-3"
            :error="errors.title ? errors.title[0] : null"
            :maxlength=200
        />
        <input-textarea
            label="* Meta Description"
            name="description"
            v-model="form.description"
            class="mt-3"
            :error="errors.description ? errors.description[0] : null"
            :maxlength=200
        />
        <media-reference
            :language="form.language"
            v-model="form.image"
            class="mt-3"
            label="Featured Image"
            :media-types="['Image', 'Logo']"
            name="profile_photo_id"
        />
        <div
            class="border bg-white rounded-lg w-full p-4 shadow-sm max-w-4xl mt-3"
        >
            <p class="text-gray-700 mb-4">Canonical</p>
            <reference
                create-text="Create new canonical and link canonical to this page"
                link-text="Link an existing canonical"
                v-model="form.canonical"
                :language="form.language"
                model-data="Page Document"
                :creatable="false"
                :error="errors.canonical_id ? errors.canonical_id[0] : null"
            />
        </div>
        <input type="hidden" name="_token" :value="csrf" />
        <input v-if="data" type="hidden" name="_method" value="patch" />
    </form>
</template>

<script>
import crudForm from "../mixins/crudForm";
export default {
    name: "MetaForm",
    mixins: [crudForm],
    data() {
        return {
            form: {
                editor_note: this.getFormData("editor_note"),
                name: this.getFormData("name"),
                title: this.getFormData("title"),
                description: this.getFormData("description"),
                image: this.getFormData("image"),
                image_id: this.getFormData("image_id"),
                canonical: this.getFormData("canonical"),
                canonical_id: this.getFormData("canonical_id"),
                canonical_type: this.getFormData("canonical_type"),
            },
        };
    },
    watch: {
        "form.image": function(newValue){
            this.form.image_id = newValue?.id || null;
        },
        "form.canonical": function(newValue){
            this.form.canonical_id = newValue?.id || null;
            this.form.canonical_type = newValue ? newValue.document_type : null;
        }
    }
};
</script>
